<template>
<div>
	<app-header></app-header>
        <v-container grid-list-xl mt-5>
            <v-layout justify-center>
                <v-flex sm12 xs12 md12 lg8 pa-0>
                    <v-card class="pa-3">
                        <v-layout>
                            <v-flex xs12 lg12 class="text-xs-center font-24 fw-700">
                                {{$t("enableAuthentication.title")}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 lg12 class="font-16">
                                <span class="fw-400 primary--text">
                                    {{$t("enableAuthentication.step1")}}
                                </span>
                                <span>
                                    {{$t("enableAuthentication.step1Msg")}}
                                </span>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs4 lg2 class="ml-5">
                                <div class="google-authentication-icon">
                                    <img src="../../../static/img/google_authenticator.jpg">
                                </div>
                            </v-flex>
                            <v-flex xs8 lg10>
                                <div class="links">
                                    <p>
                                        IOS <a class="primary--text" href="https://itunes.apple.com/cn/app/google-authenticator/id388497605" target="_blank">{{$t("enableAuthentication.download")}}</a>
                                    </p>
                                     <p>
                                        Android <a class="primary--text" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">{{$t("enableAuthentication.download")}}</a>
                                    </p>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12 lg12 class="font-16">
                                <span class="fw-bold primary--text">
                                   {{$t("enableAuthentication.step2")}} 
                                </span>
                                <span>
                                    {{$t("enableAuthentication.step2Msg")}}
                                </span>
                            </v-flex>
                            <v-flex xs12 lg12 class="ml-5">
                                <canvas id="canvas" width="160px" height="160px;"></canvas>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12 lg12 class="font-16">
                                <span class="fw-bold primary--text">
                                   {{$t("enableAuthentication.step3")}} 
                                </span>
                                <span>
                                    {{$t("enableAuthentication.step3Msg")}}
                                </span>
                            </v-flex>
                            <v-flex xs12 lg12>
                                <div class="authentication-secret-key primary--text ml-5">
                                    {{formCustom.authenticationSecret}} &nbsp;&nbsp;
                                    <Icon type="ios-copy-outline" size="20" title="Copy" @click="copySecretKey" class="secretKey" :data-clipboard-text="this.formCustom.authenticationSecret" color="#41B8BC" style="cursor:pointer;"></Icon>
                                </div>
                                <div class="font-14 mt-3">
                                    {{$t("enableAuthentication.restoreMsg")}}
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12 lg12 class="font-16">
                                <span class="fw-bold primary--text">
                                    {{$t("enableAuthentication.step4")}}
                                </span>
                                <span>
                                    {{$t("enableAuthentication.step4Msg")}}
                                </span>
                            </v-flex>
                            <v-flex xs12 lg12 class="pa-0">
                                <!-- vuetify表单 -->
                                <v-form ref="formCustom" class="ml-5">
                                    <v-flex xs6 md4 lg3>
                                        <v-text-field id="enter-verify-code" v-model="formCustom.randomCode" :counter="6" :rules="randomCodeRules" single-line outline></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 md4 lg3>
                                        <v-btn medium class="primary" dark @click="verityRandomCode('formCustom')">{{$t("common.verify")}}</v-btn>
                                    </v-flex>
                                    <v-text-field v-show="false" v-model="formCustom.id" disabled required></v-text-field>
                                    <v-text-field v-show="false" v-model="formCustom.authenticationSecret" disabled required></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<style>

</style>
<script>
import Vue from 'vue'
import Clipboard from 'clipboard'
import config from '../../config.js'
import QRCode from 'qrcode'
export default {
    data(){
    	const validateId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t("enableAuthentication.errorCallback.idBeEmpty")));
            } else {
                callback();
            }
        };
        const validateAuthenticationSecret = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t("enableAuthentication.errorCallback.secretBeEmpty")));
            } else {
                callback();
            }
        };
        const validateRandomCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t("enableAuthentication.errorCallback.codeBeEmpty")));
            } else if (!Number.isInteger(value)) {
                callback(new Error(this.$t("enableAuthentication.errorCallback.codeValue")));
            } else if((value+'').length !== 6) {
                callback(new Error(this.$t("enableAuthentication.errorCallback.codeDigits")));
            } else {
            	callback();
            }
        };
        return{
        	qrcode:'#',
            formCustom: {
                id: '',
                authenticationSecret: '',
                randomCode: '',
            },
            ruleCustom: {
                id: [
                    { validator: validateId, trigger: 'blur' }
                ],
                authenticationSecret: [
                    { validator: validateAuthenticationSecret, trigger: 'blur' }
                ],
                randomCode: [
                    { validator: validateRandomCode, trigger: 'blur' }
                ]
            },
            randomCodeRules: [          //Google随机码规则
                v => !!v || '',
                v => (v && v.length == 6) || '',
                v => /^\d{6}$/.test(v) || ''
            ],
        }
    },
    computed: {

    },
    created(){
        
    },
    mounted:function(){
        this.getUser();
        //回车提交验证码
        $(document).on('keypress','#enter-verify-code', (event) => {
            if (event.keyCode == 13) {
                this.verityRandomCode('formCustom');
            }
        })
    },
    watch:{
        '$route':'getUser'
    },        
    methods: {
    	//获得用户详情信息
    	getUser(){
            let url = config.baseUrl + "userDetail/getMe";
            this.$http.get(url).then((successData) => {
                let data = successData.data;
                if (data.resCode == 0) {
                    let userDetail = data.result;
                    this.formCustom.id = userDetail.userId;
                    this.formCustom.authenticationSecret = data.result.authenticationSecret;
                    //生成二维码
                    var canvas = document.getElementById('canvas');
                    QRCode.toCanvas(canvas, userDetail.qrcode, function (error) {
                        
                    })
                } else {
                    this.$Message.error(this.$t("common.serverError"));
                }
            },(errorData) => {
                this.$Message.error(this.$t("common.serverError"));
            });
        },
        //复制认证秘钥
        copySecretKey(){
            var clipboard = new Clipboard('.secretKey');
            clipboard.on('success', e => {
              this.$Message.success(this.$t("common.copySuccess"));
              // 释放内存
              clipboard.destroy();
            })
            clipboard.on('error', e => {
              // 该浏览器不支持自动复制
              this.$Message.error(this.$t("common.copyFailure"));
              // 释放内存
              clipboard.destroy();
            })
        },
        //vuetify验证随机码是否正确
        verityRandomCode(name){
            if (this.$refs[name].validate()) {
                let url = config.baseUrl + "user/updateAuthenticationStatus";
                this.$http.post(url, this.formCustom).then((successData) => {
                    let data = successData.data;
                    this.formCustom.randomCode = '';
                    if (data.resCode == 0) {
                        this.$Message.success(this.$t("common.success"));
                        sessionStorage.setItem('authentication', true);
                        this.$router.push({name:'userSetting'});
                        location.reload();
                    }else if(data.resCode == -1){
                        this.$Message.error(this.$t("enableAuthentication.dangerousMsg"));
                    }else if(data.resCode == -2){
                        this.$Message.error(this.$t("enableAuthentication.verificationCodeError"));
                    }else if(data.resCode == -3){
                        this.$Message.error(this.$t("common.serverError"));
                    }
                },(errorData) => {
                    this.$Message.error(this.$t("common.fail"));
                    this.formCustom.randomCode = '';
                });
            } else {
                this.$Message.error(this.$t("common.fail"));
                this.formCustom.randomCode = '';
            }
        },
        //iview验证随机码是否正确
        //提交请求
    	handleSubmit (name) {
            alert(this.formCustom.randomCode);
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let url = config.baseUrl + "user/updateAuthenticationStatus";
                    this.$http.post(url, this.formCustom).then((successData) => {
                        let data = successData.data;
                        this.formCustom.randomCode = '';
                        if (data.resCode == 0) {
                            this.$Message.success(this.$t("common.success"));
                            sessionStorage.setItem('authentication', true);
                            this.$router.push({name:'userSetting'});
                            location.reload();
                        }else if(data.resCode == -1){
                            this.$Message.error(this.$t("enableAuthentication.dangerousMsg"));
                        }else if(data.resCode == -2){
                            this.$Message.error(this.$t("enableAuthentication.verificationCodeError"));
                        }else if(data.resCode == -3){
                            this.$Message.error(this.$t("common.serverError"));
                        }
                    },(errorData) => {
                        this.$Message.error(this.$t("common.fail"));
                        this.formCustom.randomCode = '';
                    });
                } else {
                    this.$Message.error(this.$t("common.fail"));
                    this.formCustom.randomCode = '';
                }
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// EnableAuthentication.vue?22f863a1